function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 3.134a1 1 0 010 1.732L2 7.464a1 1 0 01-1.5-.866V1.402A1 1 0 012 .536l4.5 2.598z",
  fill: "#fff"
});

function SvgThickArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    fill: "none"
  }, props), _ref);
}

export default SvgThickArrowRight;